import {
  DTWeightedNode,
  WeightedNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {getBaseHeader, getDestinationPhrase, getOutputIdentifier} from './utils';

function getWeightPercent(weight: number, sumWeights: number): number {
  if (sumWeights <= 0) return 0;

  return Math.round((weight / sumWeights) * 100);
}

export function weightedCardToText(card: DTWeightedNode, mode: 'short' | 'full'): string {
  const header = getBaseHeader(card);
  const purpose = `Purpose: Select random output${
    card.shouldSplitAudience ? ' with audience split' : ''
  }.`;
  const outputs = card.outputs as WeightedNodeOutputData[];
  const sumWeights = outputs.reduce((sum, output) => sum + (output.weight ?? 0), 0);

  const outputLines =
    mode === 'full'
      ? outputs.map((output) => {
          const outputId = getOutputIdentifier(output);
          const dest = getDestinationPhrase(output.nodeId);
          const isUnconnected = !output.nodeId;
          const weight = output.weight ?? 0;
          const percent = getWeightPercent(weight, sumWeights);
          const weightPart = `${percent}% of traffic (weight: ${weight})`;
          const suffix = isUnconnected
            ? `${dest}, defined for ${weightPart}`
            : `${dest} - ${weightPart}`;

          return `Output ${outputId} ${suffix}`;
        })
      : outputs.map((output) => {
          const outputId = getOutputIdentifier(output);
          const dest = getDestinationPhrase(output.nodeId);

          return `Output ${outputId} ${dest}`;
        });

  const audienceSplitLine =
    mode === 'full' ? [`Audience Split: ${card.shouldSplitAudience ? 'True' : 'False'}`] : [];
  const purposeLine = mode === 'short' ? purpose : null;

  return [header, ...audienceSplitLine, purposeLine, ...outputLines].filter(Boolean).join('\n');
}
